/**
 * Formats a date to DD/MM/YYYY HH:mm
 * @param {string|Date} date - ISO string or Date object
 * @returns {string} Formatted date string, or "—" if invalid
 */
export function formatDate(date) {
  if (!date) return "—";

  const d = new Date(date);
  if (isNaN(d.getTime())) return "—";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
